/**
 * Resolve a server-relative image URL (`/storage/images/...`) returned by the
 * bos-api into a fully-qualified URL pointing at the bos-api host. The bos-app
 * is served from a different host in production (nginx on port 80) than the
 * bos-api (port 8080), so a bare `/storage/...` `<img src>` would hit the wrong
 * origin.
 *
 * - Returns `null`/`undefined` unchanged so callers can pass straight from the
 *   API model.
 * - Absolute URLs (`http://`, `https://`) and `data:` URLs (the cropper's
 *   pre-upload preview) pass through verbatim.
 */
export const getImageDisplayUrl = (
    relative: string | null | undefined,
    apiBaseUrl: string,
): string | null | undefined => {
    if (relative === null || relative === undefined) {
        return relative;
    }
    if (
        relative.startsWith('http://') ||
        relative.startsWith('https://') ||
        relative.startsWith('data:')
    ) {
        return relative;
    }
    return new URL(relative, apiBaseUrl).toString();
};
